import { QueryProvider } from 'aem-libs-react-components/src/components/utility/query-provider/QueryProvider'

import { BurinkaEarlyRepaymentContainer } from './containers/BurinkaEarlyRepaymentContainer'

export const App = () => {
  return (
    <QueryProvider>
      <BurinkaEarlyRepaymentContainer />
    </QueryProvider>
  )
}
